'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Headline = require('../../01.atoms/Headline/Headline.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-table',
    cnTable = "".concat(CLASSNAME, "__table"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCell = "".concat(CLASSNAME, "__cell"),
    cnFixed = "".concat(CLASSNAME, "--fixed"),
    cnCellHead = "".concat(cnCell, " ").concat(cnCell, "--head"),
    cnCellHeadTop = "".concat(cnCellHead, " ").concat(cnCell, "--top"),
    cnCellHeadSide = "".concat(cnCellHead, " ").concat(cnCell, "--side");
/**
 * 
 */

var Table = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Table, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Table);

  function Table() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "filter", function (a) {
      return !(typeof a === 'undefined' || a === null);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Table, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          title = _this$props.title,
          iconId = _this$props.iconId,
          topHeader = _this$props.topHeader,
          sideHeader = _this$props.sideHeader,
          items = _this$props.items,
          colWidth = _this$props.colWidth,
          fixed = _this$props.fixed,
          rows = _rollupPluginBabelHelpers.toConsumableArray(items).filter(this.filter);

      var topHeaderItem = [];

      if (topHeader) {
        topHeaderItem = rows.shift();
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, cnFixed, fixed))
      }, title && /*#__PURE__*/React__default.createElement(Headline, {
        level: 4,
        iconId: iconId
      }, title), /*#__PURE__*/React__default.createElement("table", {
        className: cnTable
      }, colWidth && /*#__PURE__*/React__default.createElement("colgroup", null, colWidth.filter(this.filter).map(function (width, i) {
        return /*#__PURE__*/React__default.createElement("col", {
          key: i,
          width: width
        });
      })), /*#__PURE__*/React__default.createElement("tbody", null, topHeader && /*#__PURE__*/React__default.createElement("tr", {
        className: cnRow
      }, topHeaderItem.filter(this.filter).map(function (cell, i) {
        return /*#__PURE__*/React__default.createElement("th", {
          className: cnCellHeadTop,
          key: i
        }, cell);
      })), rows.map(function (item, i) {
        return /*#__PURE__*/React__default.createElement("tr", {
          className: cnRow,
          key: i
        }, item.filter(_this2.filter).map(function (cell, j) {
          return sideHeader && j === 0 ? /*#__PURE__*/React__default.createElement("th", {
            className: cnCellHeadSide,
            key: j
          }, cell) : /*#__PURE__*/React__default.createElement("td", {
            className: cnCell,
            key: j
          }, cell);
        }));
      }))));
    }
  }]);

  return Table;
}(React__default.Component);
Table.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Array to group columns */
  colWidth: PropTypes.array,

  /** True for fixed styling */
  fixed: PropTypes.bool,

  /** Id of icon */
  iconId: PropTypes.string,

  /** Array of table items */
  items: PropTypes.array.isRequired,

  /** True for header on the side */
  sideHeader: PropTypes.bool,

  /** Title of table */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** True for header at top */
  topHeader: PropTypes.bool
};
Table.defaultProps = {
  items: [['N/A', 'N/A'], ['N/A', 'N/A']]
};

module.exports = Table;
